"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var ValuableItemModal_1 = require("./ValuableItemModal");
var services_1 = require("@falcon/services");
var uuid_1 = require("uuid");
var core_1 = require("@athena-portal/core");
var Types_1 = require("../../../../Types");
var commonFunctions_1 = require("../../../../commonFunctions");
var ConfirmModal_1 = require("../../../../components/modals/ConfirmModal");
var ValuableItems = /** @class */ (function (_super) {
    __extends(ValuableItems, _super);
    function ValuableItems(props) {
        var _this = _super.call(this, props) || this;
        _this.itemsCountLimit = 10;
        _this.handleNextButton = function () {
            var nextButton = document.getElementById(services_1.NEXT_BUTTON_ID);
            var interaction = _this.props.interaction;
            if (nextButton) {
                if (interaction.valuableItems && interaction.valuableItems.length > 0) {
                    nextButton.disabled = false;
                }
                else {
                    nextButton.disabled = _this.state.specifiedItemsSelected === null;
                }
            }
        };
        _this.renderItems = function () {
            var interaction = _this.props.interaction;
            var valuablesAdded = interaction.valuableItems && interaction.valuableItems.length > 0;
            if (valuablesAdded || interaction.process !== services_1.INTERACTION_PROCESS_NB) {
                var items = valuablesAdded && interaction.valuableItems.map(function (item, index) {
                    return ((0, jsx_runtime_1.jsxs)("div", { children: [index !== 0 && (0, jsx_runtime_1.jsx)("div", { className: "dashed-10 my-4" }), (0, jsx_runtime_1.jsx)("div", { id: "specifiedItem-description-".concat(item.valuableItemId), children: item.description }), (0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)("b", { children: item.coverLocation === services_1.ValuableItemCoverLocation.HOME ? "Cover inside the home" : "Cover inside and outside the home" }), " for ", (0, jsx_runtime_1.jsxs)("b", { children: ["\u00A3", item.value] })] }), (0, jsx_runtime_1.jsxs)("div", { children: ["Monthly price: ", (0, jsx_runtime_1.jsx)("b", { children: (0, commonFunctions_1.getAmountToDisplay)(item.premium) })] }), !(interaction.uistate.itemIds && interaction.uistate.itemIds.includes(item.valuableItemId)) && ((0, jsx_runtime_1.jsxs)("div", { className: "d-flex justify-content-between justify-content-md-start mt-2 font-weight-medium text-blue-1 text-decoration-underline", children: [(0, jsx_runtime_1.jsx)("span", { onClick: function () { return _this.showItemModal(item); }, className: "mr-5 cursor-pointer", children: "Edit" }), (0, jsx_runtime_1.jsx)("span", { onClick: function () { return _this.setState({ showRemoveConfirmation: true, itemToInteract: item }); }, className: "cursor-pointer", children: "Remove" })] }))] }, item.valuableItemId));
                });
                return ((0, jsx_runtime_1.jsxs)("div", { className: "mt-2 mb-5 p-3 upload", children: __spreadArray(__spreadArray([], items, true), [!interaction.valuableItems ||
                            (interaction.valuableItems && interaction.valuableItems.length < 10 &&
                                (0, commonFunctions_1.calculateValuablesTotalValue)(interaction.valuableItems) < 20000) && ((0, jsx_runtime_1.jsxs)("div", { className: "text-center", children: [(0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [valuablesAdded && (0, jsx_runtime_1.jsx)("div", { className: "dashed-10 my-4" }), (0, jsx_runtime_1.jsx)("div", { className: "my-4", children: (0, jsx_runtime_1.jsx)("b", { children: "Add up to 10 items" }) })] }), (0, jsx_runtime_1.jsx)("img", { src: "/img/Flow-plus.svg", alt: "Add item icon", onClick: function () { return _this.showItemModal(); } })] }))], false) }));
            }
            else {
                return ((0, jsx_runtime_1.jsx)("div", { className: "form-group mt-4", children: (0, jsx_runtime_1.jsxs)("div", { className: "input-group width-450", role: "group", children: [(0, jsx_runtime_1.jsxs)("div", { className: "custom-control custom-radio", children: [(0, jsx_runtime_1.jsx)("input", { className: "custom-control-input", type: "radio", name: "specified-items-radio", id: "has-items", value: "true", checked: _this.state.specifiedItemsSelected === true }), (0, jsx_runtime_1.jsx)("label", { className: "custom-control-label", htmlFor: "has-items", onClick: function () { return _this.showItemModal(); }, children: "Yes" })] }), (0, jsx_runtime_1.jsxs)("div", { className: "custom-control custom-radio", children: [(0, jsx_runtime_1.jsx)("input", { className: "custom-control-input", type: "radio", name: "specified", id: "has-no-items", value: "false", checked: _this.state.specifiedItemsSelected === false, onChange: function () { return _this.setState({ specifiedItemsSelected: false }); } }), (0, jsx_runtime_1.jsx)("label", { className: "custom-control-label", htmlFor: "has-no-items", children: "No" })] })] }) }));
            }
        };
        _this.showItemModal = function (item) {
            _this.props.engine.setJourneyState({
                originalValuableItems: __spreadArray([], _this.props.interaction.valuableItems, true)
            });
            if (item) {
                _this.setState({ showEditItemModal: true, itemToInteract: item });
            }
            else {
                _this.setState({ showAddItemModal: true, itemToInteract: new services_1.ValuableItem() });
            }
        };
        _this.closeAddModal = function () {
            _this.restoreOriginalItems().then(function () {
                _this.setState({ showAddItemModal: false, specifiedItemsSelected: _this.props.interaction.valuableItems.length > 0 });
            });
        };
        _this.closeEditModal = function () {
            _this.restoreOriginalItems().then(function () {
                _this.setState({ showEditItemModal: false });
            });
        };
        _this.removeItem = function (item) {
            var items = _this.props.interaction.valuableItems;
            var index = items.map(function (i) { return i.valuableItemId; }).indexOf(item.valuableItemId);
            items.splice(index, 1);
            _this.setState({ showRemoveConfirmation: false, specifiedItemsSelected: (!(!items || items.length === 0)) });
            _this.props.onStateChange("valuableItems", items);
            _this.executeEvent("change");
            _this.changelogRecorder.recordPage("change", _this.props, "valuableItems");
        };
        _this.confirmItem = function (item) {
            var items = _this.props.interaction.valuableItems;
            var index = items.map(function (i) { return i.valuableItemId; }).indexOf(item.valuableItemId);
            items.splice(index, 1, item);
            _this.props.onStateChange("valuableItems", items);
            _this.executeEvent("change");
            _this.setState({ showEditItemModal: false, showAddItemModal: false, specifiedItemsSelected: true });
            _this.changelogRecorder.recordPage("change", _this.props, "valuableItems");
        };
        _this.checkItemCost = function (item) {
            var interaction = _this.props.interaction;
            var items = interaction.valuableItems || [];
            var premiumBeforeItemConfirmation = _this.props.engine.getInteraction().factors.premium;
            if (item.valuableItemId) {
                var index = items.map(function (i) { return i.valuableItemId; }).indexOf(item.valuableItemId);
                items.splice(index, 1, item);
                _this.props.onStateChange("valuableItems", items);
                _this.executeEvent("change").then(function () {
                    _this.props.onStateChange("factors.premium", premiumBeforeItemConfirmation);
                    _this.setState({ itemToInteract: _this.props.engine.getInteraction().valuableItems.filter(function (vi) { return vi.valuableItemId === item.valuableItemId; })[0] });
                });
            }
            else {
                item.valuableItemId = (0, uuid_1.v4)();
                var length_1 = items.push(item);
                _this.props.onStateChange("valuableItems", items);
                _this.executeEvent("change").then(function () {
                    _this.props.onStateChange("factors.premium", premiumBeforeItemConfirmation);
                    _this.setState({ itemToInteract: _this.props.engine.getInteraction().valuableItems[length_1 - 1] });
                });
            }
            _this.changelogRecorder.recordPage("change", _this.props, "valuableItems");
        };
        _this.state = {
            showAddItemModal: false,
            showEditItemModal: false,
            showRemoveConfirmation: false,
            specifiedItemsSelected: null
        };
        _this.restoreOriginalItems = _this.restoreOriginalItems.bind(_this);
        return _this;
    }
    ValuableItems.prototype.componentDidMount = function () {
        this.handleNextButton();
    };
    ValuableItems.prototype.componentDidUpdate = function () {
        this.handleNextButton();
    };
    ValuableItems.prototype.render = function () {
        var _this = this;
        var interaction = this.props.interaction;
        var valuableItems = interaction.valuableItems;
        return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("div", { className: "mt-3", children: valuableItems && valuableItems.length > 0
                        ? valuableItems.length < this.itemsCountLimit
                            ? (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: ["You have added ", (0, jsx_runtime_1.jsx)("b", { children: valuableItems.length }), " out of 10 items worth in total of ", (0, jsx_runtime_1.jsxs)("b", { children: ["\u00A3", (0, commonFunctions_1.calculateValuablesTotalValue)(valuableItems)] })] })
                            : (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: ["You have ", (0, jsx_runtime_1.jsx)("b", { children: this.itemsCountLimit }), " items added and you have reached your limit"] })
                        : (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {}) }), this.renderItems(), this.state.showAddItemModal && this.state.itemToInteract && ((0, jsx_runtime_1.jsx)(ValuableItemModal_1.default, { show: this.state.showAddItemModal, hide: this.closeAddModal, item: this.state.itemToInteract, title: "Add item", existingItem: false, onConfirm: this.confirmItem, onCheck: this.checkItemCost, totalValueOfItems: (0, commonFunctions_1.calculateValuablesTotalValue)(valuableItems), insuredValue: interaction.factors.insuredValue })), this.state.showEditItemModal && this.state.itemToInteract && ((0, jsx_runtime_1.jsx)(ValuableItemModal_1.default, { show: this.state.showEditItemModal, hide: this.closeEditModal, item: this.state.itemToInteract, title: "Edit item", existingItem: true, onConfirm: this.confirmItem, onCheck: this.checkItemCost, totalValueOfItems: (0, commonFunctions_1.calculateValuablesTotalValue)(valuableItems) - Number(this.state.itemToInteract.value), insuredValue: interaction.factors.insuredValue })), this.state.showRemoveConfirmation && ((0, jsx_runtime_1.jsx)(ConfirmModal_1.default, { show: this.state.showRemoveConfirmation, onHide: function () { return _this.setState({ showRemoveConfirmation: false }); }, onConfirm: function () { return _this.removeItem(_this.state.itemToInteract); }, confirmButtonText: "Yes, please", children: (0, jsx_runtime_1.jsx)("div", { className: "fs-20 font-weight-bold font-family-display", children: "Are you sure you want to remove this item from your cover?" }) }))] }));
    };
    ValuableItems.prototype.restoreOriginalItems = function () {
        return __awaiter(this, void 0, void 0, function () {
            var journeyState, interaction;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        journeyState = this.props.engine.getJourneyState();
                        interaction = this.props.engine.getInteraction();
                        interaction.valuableItems = journeyState.originalValuableItems;
                        interaction.realEstates[0].valuableItemIds = journeyState.originalValuableItems.map(function (i) { return i.valuableItemId; });
                        this.props.engine.callInteractionSetState(interaction);
                        return [4 /*yield*/, this.executeEvent("change")];
                    case 1:
                        _a.sent();
                        this.changelogRecorder.recordPage("change", this.props, "valuableItems");
                        return [2 /*return*/, Promise.resolve()];
                }
            });
        });
    };
    ;
    __decorate([
        (0, core_1.lazyInject)(Types_1.Types.ChangelogRecorder),
        __metadata("design:type", Object)
    ], ValuableItems.prototype, "changelogRecorder", void 0);
    return ValuableItems;
}(plugin_journey_1.WidgetBase));
exports.default = ValuableItems;
//# sourceMappingURL=ValuableItems.js.map